import { AbstractControl } from '@angular/forms';
import { DepartmentsDTO } from '@core/models';

export function applyDepartmentFieldsUpdate(
  departmentsField: AbstractControl<string | null, string | null>,
  departmentIdsField: AbstractControl<number[] | null, number[] | null>,
  allDepartmentsAccessField: AbstractControl<boolean>,
  allDepartments: boolean,
  selectedDepartments?: DepartmentsDTO[],
): void {
  if (allDepartments) {
    departmentsField.setValue('All Departments');
    allDepartmentsAccessField.setValue(true);
    departmentIdsField.setValue([]);
  } else if (selectedDepartments && selectedDepartments.length > 0) {
    // Format department names as comma-separated string for template display
    const departmentNames = selectedDepartments.map((dept) => dept.name).join(', ');
    departmentsField.setValue(departmentNames);

    // Store department IDs for submitting
    const departmentIds = selectedDepartments.map((dept) => dept.id);
    departmentIdsField.setValue(departmentIds);
    allDepartmentsAccessField.setValue(false);
  } else {
    // No departments assigned
    departmentsField.setValue(null);
    departmentIdsField.setValue(null);
    allDepartmentsAccessField.setValue(false);
  }

  departmentsField.markAsTouched();
}
